import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import '../../styles.css';

BCarousel.propTypes = {
  className: PropTypes.string, // necessaire pour styled
  items: PropTypes.arrayOf(PropTypes.element),
};

function BCarousel({className,items}) {

  // TODO : les passer en config
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <Slider {...settings} className={className + ' carousel'}>
      {items.map((itemEl,index) => {
        const El = itemEl;
        return El;
      })}
    </Slider>
  );
}

const Carousel = styled(BCarousel)`

`;

export default Carousel;
